// The company a request from this page is for, sent as a Sendinvo-Company
// header on every request (server/device-sessions.js, webCompanyHook). A browser
// has one session for every tab, and the session's company is whichever tab
// switched last. Named on changes only, a tab left open on one company read
// another's settings and saved them over its own, offered clients it couldn't
// use, and opened a Checkout on the wrong company. So reads name it too, which
// makes each new address ask the API first (server/app.js keeps the answer as
// long as a browser will).

/**
 * @param {string|null|undefined} companyId  the company this page is showing
 * @returns {string|null} the header's value, or null for no header
 */
export function companyHeaderFor(companyId) {
  return companyId ? String(companyId) : null;
}

/**
 * Whether a refusal means the company this page is showing has gone from under
 * it: the person was removed, or it was deleted, since the page loaded. Only
 * for the header the page sent for itself. A caller naming a company of its
 * own (Profile's Leave) has its own answer to give.
 */
export function pageLostItsCompany(status, body, namedByPage) {
  return Boolean(namedByPage) && status === 403 && body?.error === "NotAMember";
}
